export default __webpack_public_path__ + "static/media/CNo.88-3.34eecd4d.jpg";